var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftsDiscountsGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Offer Icon / gifts_discounts_gray") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707784",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E535C",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Offer-Icon-/-gifts_discounts_gray",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25,13.5 C23.6624908,13.5 24,13.1624908 24,12.75 L24,9 C24,8.17030334 23.3296967,7.5 22.5,7.5 L20.5265808,7.5 C20.8171692,6.93283081 21,6.3046875 21,5.625 C21,3.3515625 19.1484375,1.5 16.875,1.5 C14.9250183,1.5 13.6640625,2.49842834 12.046875,4.70155334 C10.4296875,2.49842834 9.16873169,1.5 7.21875,1.5 C4.9453125,1.5 3.09375,3.3515625 3.09375,5.625 C3.09375,6.3046875 3.27186584,6.93283081 3.56716919,7.5 L1.5,7.5 C0.670303345,7.5 0,8.17030334 0,9 L0,12.75 C0,13.1624908 0.337509155,13.5 0.75,13.5 L23.25,13.5 Z M11.25,7.5 L7.21408081,7.5 C6.17811584,7.5 5.33908081,6.66091919 5.33908081,5.625 C5.33908081,4.58908081 6.17811584,3.75 7.21408081,3.75 C8.14686584,3.75 8.8359375,3.90467834 11.25,7.5 Z M16.875,7.5 L12.8390808,7.5 C14.9921148,4.29554521 15.7564326,3.82363343 16.577079,3.75949257 L16.6948534,3.75285251 C16.7540883,3.75066843 16.8139616,3.75 16.875,3.75 C17.9109192,3.75 18.75,4.58908081 18.75,5.625 C18.75,6.66091919 17.9109192,7.5 16.875,7.5 Z M10.5,22.5 L10.5,15 L1.5,15 L1.5,21 C1.5,21.8296967 2.17030334,22.5 3,22.5 L10.5,22.5 Z M21,22.5 C21.8296967,22.5 22.5,21.8296967 22.5,21 L22.5,15 L13.5,15 L13.5,22.5 L21,22.5 Z",
    id: "icon",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftsDiscountsGray);
export default __webpack_public_path__ + "static/media/gifts_discounts_gray.c8a193a521356a6c7a63de1ad6824281.svg";
export { ForwardRef as ReactComponent };